import React from "react";
import "../../scss/customerpolicy/policies.scss";


function Conditions() {
  return (
    <div className="Policy">
      <div className="container">
        <div className="Content">
          <div className="policy">
            <h2>1.</h2>
            <p>
              Behoudens andersluidende schriftelijke overeenkomst wordt de
              rechtsverhouding tussen partijen geregeld door deze algemene
              factuurvoorwaarden waarvan de klant verklaart kennis te hebben
              genomen, en die prevaleren op de gebeurlijke eigen algemene
              voorwaarden van de klant. Elke bestelling betekent de aanvaarding
              door de klant van deze voorwaarden
            </p>
            <br></br>
          </div>
          <div className="policy">
            <h2>2.</h2>
            <p>
              Alle offertes zijn vrijblijvend en niet bindend voor Decoratie
              Degezelle.
            </p>
            <br></br>
          </div>
          <div className="policy">
            <h2>3.</h2>
            <p>
              Indien de overeengekomen prijzen wijzigingen ondergaan met een
              steiging boven 30% die buiten onze wil vallen, zoals wijzigingen
              van de prijzen van de toeleveranciers, schommelingen van
              grondstofprijzen en hulpmaterialen, wijzigingen van de lonen,
              herwaarderingen van vreemde munten, invoerrechten en
              vervoerskosten of rentevoeten en dit tot op de dag van de
              levering, overheidsvoorschriften of andere dwingende maatregelen,
              behouden wij ons het recht voor de prijzen op evenredige wijze aan
              te passen. Er zal in wederzijds overleg met de klant een nieuw
              prijsvoorstel gedaan worden.
            </p>
            <br></br>
          </div>
          <div className="policy">
            <h2>4.</h2>
            <p>
              De leveringstermijnen worden enkel bij wijze van inlichtingen
              verstrekt en binden de aannemer niet. Bij vertraging in de
              uitvoering van de werken heeft men geen recht op schadevergoeding,
              noch op ontbinding van de overeenkomst.
            </p>
            <br></br>
          </div>
          <div className="policy">
            <h2>5.</h2>
            <p>
              De klant zal steeds instaan voor de bewaking en de bewaring van de
              goederen ondergebracht of geplaatst in onafgewerkte of onbewoonde
              gebouwen.
            </p>
            <br></br>
          </div>
          <div className="policy">
            <h2>6.</h2>
            <p>
              Wij behouden ons het recht voor om de overeenkomst van rechtswege
              en zonder voorafgaande ingebrekestelling als ontbonden te
              beschouwen in geval van faillissement, kennelijk onvermogen,
              alsook bij om het even welke wijziging in de juridische toestand
              van de opdrachtgever.
            </p>
            <br></br>
          </div>
          <div className="policy">
            <h2>7.</h2>
            <p>
              Al onze facturen zijn netto en zonder korting betaalbaar te
              Harelbeke 14 dagen na factuurdatum. Iedere vertraging in de
              betaling zal van rechtswege en zonder aanmaning een intrest van 1
              % per maand meebrengen voor de debiteur. Indien u na het zenden
              van een aanmaning in gebreke blijft, zal het factuurbedrag
              nogmaals (met een minimum van 125 EUR) verhoogd worden. Bij
              gebeurlijke gerechtelijke invordering en betwisting erkennen de
              betrokken partijen uitsluitend de bevoegdheid van de rechtbank van
              het gerechtelijk arrondissement Kortrijk.
            </p>
            <br></br>
          </div>
          <div className="policy">
            <h2>8. </h2>
            <p>
              Het protest tegen de factuur dient schriftelijk en aangetekend te
              gebeuren binnen de acht dagen na de factuurdatum. Men wordt
              verzocht steeds de datum en het nummer van de factuur te
              vermelden.
            </p>
            <br></br>
          </div>
          <div className="policy">
            <h2>9.</h2>
            <p>
              Bij niet betaling houden wij ons het recht voor om verdere
              levering van goederen of diensten stop te zetten tot dat de
              betalingsvoorwaarden zijn voldaan. Tevens behouden wij ons het
              recht voor om de overeenkomst van rechtswege en zonder vooraf-
              gaande ingebrekestelling als ontbonden te beschouwen voor het
              geheel of het nog niet uitgevoerde gedeelte.
            </p>
            <br></br>
          </div>
          <div className="policy">
            <h2>10.</h2>
            <p>
              Zolang de geleverde goederen niet werden betaald, blijven zij
              eigendom van de aannemer. In afwijking van art. 1583 van het
              Gerechtelijk Wetboek wordt het eigendomsrecht over de verkochte
              goederen slechts aan de koper overgedragen na de volledige
              betaling van de overeengekomen prijs. Het risico gaat echter over
              op de koper van bij het afsluiten van de overeenkomst.
            </p>
            <br></br>
          </div>
          <div className="policy">
            <h2>11.</h2>
            <p>
              Indien de klant de overeenkomst verbreekt of annuleert of indien
              de overeenkomst door zijn toedoen geen doorgang kan vinden, is
              deze aan ons een schadevergoeding verschuldigd ten bedrage van 30
              % van het totaalbedrag.
            </p>
            <br></br>
          </div>
          <div className="policy">
            <h2>12.</h2>
            <p>
              Wij zijn niet verantwoordelijk als er schade is door af te plakken
              met tape.Op muren,plafonds,… die wij zelf niet hebben bewerkt.
            </p>
            <br></br>
          </div>
          <div className="policy">
            <h2>13.</h2>
            <p>
              Werken in regie en bijkomende werken op de offerteaanvraag worden
              exclusief materiaal en btw aangerekend op 40€ /uur.
            </p>
            <br></br>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Conditions;
